'use client';

import React, { useMemo } from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

import { Seat, SeatCategory } from '@cineamo/ui/src/seat-map/typedefs';

import { useCartProvider } from '../providers/cartProvider';

import ConcessionCartItem from './ConcessionCartItem';
import { roomSeatCategories } from './seat-showcase';
import SelectedSeatCartItem from './SelectedSeatCartItem';

type CartSummaryProps = {
    seats: Seat[];
    /** Given on seat picking and the cart: each seat gets an x that drops it. */
    onRemoveSeat?: (seatId: Seat['id']) => void;
    /** Opens a seat category's showcase modal from its line. */
    onShowCategory?: (category: SeatCategory) => void;
    className?: string;
};

const CartSummary: React.FC<CartSummaryProps> = ({ seats, onRemoveSeat, onShowCategory, className }) => {
    const { selectedSeats, currentStep, concessions } = useCartProvider();
    const roomCategories = useMemo(() => roomSeatCategories(seats), [seats]);
    return (
        <div
            className={cn(
                'mx-[9px] lg:mx-[16px] lg:m-[16px] space-y-[8px]',
                {
                    'hidden lg:flex': !['01_seat_picking', '01.5_cart', '02_payment'].includes(currentStep)
                },
                className
            )}>
            {selectedSeats.flatMap((selectedSeat) => {
                const seat = seats.find((s) => s.id === selectedSeat.id);
                if (!seat) {
                    return [];
                }
                return (
                    <SelectedSeatCartItem
                        key={seat.id}
                        seat={seat}
                        roomCategories={roomCategories}
                        selectedSeat={selectedSeat}
                        isDisabled={currentStep !== '01_seat_picking' && currentStep !== '01.5_cart'}
                        onShowCategory={onShowCategory}
                        onRemove={onRemoveSeat && (() => onRemoveSeat(seat.id))}
                    />
                );
            })}
            {concessions.map((concession) => (
                <ConcessionCartItem
                    key={concession.id}
                    concession={concession}
                    isEditable={currentStep === '01.5_cart'}
                />
            ))}
            {/* {cart.items
                        .filter((item) => item._embedded.product.type === 'SeatLock')
                        .map((cartItem) => (
                            <SelectedSeatCartItem
                                key={cartItem._embedded.product.id}
                                cartItem={cartItem}
                                discounts={priceDiscounts}
                                currency={cart.currency}
                                onDiscountSelect={(selectedDiscount) =>
                                    applyDiscount(cartItem._embedded.product.id, selectedDiscount)
                                }
                            />
                        ))} */}

            {/* {items
                        .filter((item) => item._embedded.product.type === '')
                        .map((cartItem) => (
                            <SelectedCartItem
                                key={cartItem.id}
                                cartItem={cartItem}
                                currency={currency}
                            />
                        ))} */}
        </div>
    );
};

export default CartSummary;
